document.addEventListener("turbolinks:load", function (event) {
  const togglevisitorRejectionSection = document.querySelector("#toggle-visitor-rejection-section");
  if (togglevisitorRejectionSection) {
    togglevisitorRejectionSection.addEventListener("click", function () {
      document.querySelector("#visitor-rejection-section").classList.toggle("hidden");
    })
  }
});